import styled from 'styled-components';
import { Hint } from 'venn-ui-kit';

export const EmptyResults = styled(Hint)`
  display: block;
  text-align: center;
  padding-top: 24px;
`;
